import { Injectable }    from '@angular/core';

@Injectable()
export class DateService {

    constructor() {
    }

    convertToLocalDateString(date: any){
        let localDate : any = new Date(date);
        return localDate = localDate.toLocaleDateString("es-AR", "Argentina/Buenos Aires") + " " + localDate.toLocaleTimeString("es-AR", "Argentina/Buenos Aires");
    }

}



// WEBPACK FOOTER //
// ./src/app/services/date.service.ts